import "react-toastify/dist/ReactToastify.css";
/* eslint-disable react-hooks/exhaustive-deps */
import AppController from "controllers/app";
import AuthController from "controllers/authController";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RoutesBuilder from "routes";
import { setLanguage, setTranslations } from "store/reducers/app";
import { langIdSelector } from "store/selectors/app";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "./utils/errorBoundary";
import { EventBus } from "utils";
import LoginPopup from "components/login/loginPopup";

import { generateToken, messaging } from "notifications/firebase"; // , listenForTokenRefresh
import { onMessage } from "firebase/messaging";

export default function App() {
  const langId = useSelector(langIdSelector);
  const dispatch = useDispatch();
  const [, setIsLoggedIn] = useState(false);
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    if (navigator.serviceWorker) {
      generateToken();
      // listenForTokenRefresh();
      if (messaging) {
        onMessage(messaging, (payload) => {
          console.log("Message received. ", payload);
          // TODO - implement foreground notification handling here
          // payload has payload.notification.title, payload.notification.body, payload.notification.image
        });
      }
    }
  }, []);

  useEffect(() => {
    const showPopup = () => setVisible(true);

    EventBus.subscribe("showLoginPopup", showPopup);

    return () => {
      EventBus.unsubscribe("showLoginPopup", showPopup);
    };
  }, []);

  useEffect(() => {
    const initializeApp = async () => {
      const storedLangId = localStorage.getItem("langId") || "US";

      if (!langId) {
        dispatch(setLanguage(storedLangId));
      }

      const effectiveLangId = langId || storedLangId;

      try {
        const fetchedTranslations = await AppController.getTranslations(
          effectiveLangId
        );
        const cachedTranslations = localStorage.getItem(
          `translations_${effectiveLangId}`
        );

        if (
          !cachedTranslations ||
          JSON.stringify(fetchedTranslations) !== cachedTranslations
        ) {
          localStorage.setItem(
            `translations_${effectiveLangId}`,
            JSON.stringify(fetchedTranslations)
          );
          dispatch(setTranslations(fetchedTranslations));
        } else {
          dispatch(setTranslations(JSON.parse(cachedTranslations)));
        }
      } catch (error) {
        console.error("Error fetching translations:", error);
      }

      checkLoginStatus();
    };

    initializeApp();
  }, [langId, dispatch]);

  const checkLoginStatus = () => {
    const isLoggedIn = AuthController.isUserLoggedIn();
    setIsLoggedIn(isLoggedIn);
  };

  return (
    <ErrorBoundary>
      <div className="w-100 homepage-wrapper">
        <ToastContainer />
        <RoutesBuilder />
        {isVisible && <LoginPopup setVisible={setVisible} />}
      </div>
    </ErrorBoundary>
  );
}
